<script src="https://unpkg.com/bootstrap-vue@2.21.2/dist/bootstrap-vue.min.js"></script>

<template>
  <div>
    <div style="overflow-x:auto;">
      <table style="column-width:50px; white-space:normal;">
        <tr>
          <th class="column-1"></th>
          <th class="column-1">Daily Price</th>
          <th class="column-1">Title</th>
          <th class="column-1">Source</th>
          <th class="column-1">AirBNB URL</th>
          <th class="column-1">iCal URL</th>
          <th class="column-1">Address</th>
          <th class="column-1"># Bedrooms</th>
          <th class="column-1"># Bathrooms</th>
          <th class="column-1"></th>
        </tr>
        <tr v-for="listing in data" v-bind:key="listing['id']">
          <td>
            <img :src="listing['images'][0]" style="width:80px;height:64px;"/>
          </td>
          <td>{{ listing['dailyRoomPrice'] }}</td>
          <td>{{ listing['title'] }}</td>
          <td>{{ listing['source'] }}</td>
          <td><a :href="listing['airBnbURL']">AirBNB Link</a></td>
          <td><a :href="listing['icalURL']">iCal Link</a></td>
          <td>{{ listing['address'] }}</td>
          <td>{{ listing['totalBedrooms'] }}</td>
          <td>{{ listing['totalBaths'] }}</td>
          <td>
            <button @click="editListing(listing['id'])">Edit</button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'ListingsPage',
  props: {},
  mounted() {
    this.operatorId = localStorage.getItem("userId");

    axios.get(`${this.baseURL}/api/listing?operatorId=${this.operatorId}`)
        .then(res => {
          this.data = res.data;
        });
  },
  data: () => ({
    data: [],
    operatorId: '',
    showModal: false,
    baseURL: 'https://crossover-api-dot-elite-pointer-290612.uc.r.appspot.com'
  }),
  methods: {
    editListing(id) {
      this.$router.push('/edit_listing/' + id).catch(failure => {
        console.log(failure);
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}


table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 80%;
  border: 1px solid #ddd;
}

th, td {
  text-align: left;
  padding: 12px;
}

tr:nth-child(even) {
  background-color: #f2f2f2
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  padding-bottom: 40px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
